import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';
import { BASE_URL } from '../../constants';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService,
        @Inject("BASE_URL") private baseurl: string
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        let isAuthorized: boolean = false;

        var accessToken = sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);

        // if access token is not there then go to auth component
        if (!accessToken) {
            this.router.navigate(["authorize"]);
        }
        else {
            // if access token is available then check if its about to expire if yes then refresh token..
            if (this.isTokenAboutToExpire(accessToken)) {
                let refreshToken = sessionStorage.getItem(environment.REFRESH_TOKEN_KEY);
                if (refreshToken) {
                    this.authService.getRefreshToken(refreshToken).then(data => { });
                }
            }
        }

        // check for auth code in the url
        if (route.queryParams.code) {
            // if authocode then navigate to authorize component with authcode as query parameter.
            let code = route.queryParams.code;
            let url = `/authorize?code=${code}`;
            this.router.navigate(["/authorize"], {
                queryParams: {
                    code: code,
                }
            });
            return Promise.resolve(true);
        }
        else {
            let token = sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);

            if (token) {
                if (this.isTokenExpired(token)) {
                    window.location.href = `${this.baseurl}api/auth/redirect-auth`
                }
                return Promise.resolve(true);
            }
            return Promise.resolve(isAuthorized);
        }
    }

    isTokenAboutToExpire(token: string) {
        let tokenExpiryDateTime = new Date(this.parseJWT(token).exp * 1000);
        let tokenExpiryDateTimeMinusFiveMins = new Date(this.parseJWT(token) - 5 * 60 * 1000);
        return (new Date() >= tokenExpiryDateTimeMinusFiveMins) && (new Date() < tokenExpiryDateTime);
    }

    isTokenExpired(token: string) {
        let tokenExpiryDateTime = new Date(this.parseJWT(token).exp * 1000);
        return new Date > tokenExpiryDateTime;
    }

    private parseJWT(token: string) {
        try {
            let base64Url = token.split('.')[1];
            let base64 = base64Url.replace('-', '+').replace('_', '/');
            return JSON.parse(atob(base64));
        } catch (error) {
            return null;
        }
    }
}
